import { TeaserData } from "@app/types/ServerCustomContext";
import { configCategory } from "@pub/config";
import placeholders from "@pub/placeholders";
import { Arrow, VideoGalleryLandscape } from "@sphtech/dmg-design-system";
import cx from "classnames";

import styles from "./subanchorvideo.module.css";

type SubAnchorVideoProps = {
  videoGallery?: {
    title?: string;
    teasers: TeaserData[];
  };
};

const SubAnchorVideo = ({ videoGallery }: SubAnchorVideoProps) => {
  // Arrow configurations for VideoGalleryLandscape
  const spotlightArrowSize =
    configCategory.videoGalleryLandscape?.spotlight?.arrowSize;
  const spotlightArrowVariant =
    configCategory.videoGalleryLandscape?.spotlight?.arrowVariant;
  const stripArrowSize = configCategory.videoGalleryLandscape?.strip?.arrowSize;
  const stripArrowVariant =
    configCategory.videoGalleryLandscape?.strip?.arrowVariant;
  const mobileArrowSize =
    configCategory.videoGalleryLandscape?.mobileNavLooping?.arrowSize;
  const mobileArrowVariant =
    configCategory.videoGalleryLandscape?.mobileNavLooping?.arrowVariant;

  if (
    !configCategory.videoGalleryLandscape?.display ||
    !videoGallery ||
    videoGallery.teasers.length === 0
  ) {
    return null;
  }

  return (
    <div className={styles.videoGalleryLayout}>
      <VideoGalleryLandscape
        title="videos"
        items={videoGallery.teasers.map((item) => {
          const crop = item.image?.crops.landscape || placeholders.landscape;
          return {
            ...crop,
            videoUrl: item.embedUri,
            sections: item.sections,
            caption: item.title,
            captionUrl: item.path,
            description: item.description,
          };
        })}
        arrowSize={spotlightArrowSize}
        arrowVariant={spotlightArrowVariant}
        strip={{
          arrowSize: stripArrowSize,
          arrowVariant: stripArrowVariant,
          dividerVariant: configCategory.dividerVariant || "primary",
        }}
        Imu={false}
        hasLabelContainer={
          configCategory.videoGalleryLandscape.hasLabelContainer
        }
        hasPagination={false}
        hasSummaryItemPublishedDate={false}
        mobileLoopingArrowsBelow={{
          showArrows:
            configCategory.videoGalleryLandscape.mobileNavigation || false,
          leftIcon: (
            <div
              className={cx(
                mobileArrowVariant === "circle" && styles.circleAround,
              )}
            >
              <Arrow direction="left" size={mobileArrowSize ?? 40} />
            </div>
          ),
          rightIcon: (
            <div
              className={cx(
                mobileArrowVariant === "circle" && styles.circleAround,
              )}
            >
              <Arrow size={mobileArrowSize ?? 40} />
            </div>
          ),
        }}
      />
    </div>
  );
};

export default SubAnchorVideo;
